module.exports = __webpack_public_path__ + "band_6.f86c303e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_6.png
// module id = bpUk
// module chunks = 0